export default __webpack_public_path__ + "static/media/withdraw-ecredit-step1.241acb20.png";